import React from 'react';
import styles from './CTA.styl';
import Button from '../button/Button';

const CTA = props => {
  return (
        <div className={styles.ctaBG}>
          <h1>Donate now to help save the ESA <span>and protect animals around the world.</span></h1>
          <div className={styles.buttonWrapper}>
            <a href=" https://secure.ifaw.org/international/give-to-solve?ms=UONDG191107030&cid=7013k000001NeBV" target="_blank" rel="noopener noreferrer">
            <Button title="Donate" color="#ffab77" />
            </a>
          </div>
        </div>

  );
};

export default CTA;



// WEBPACK FOOTER //
// ./src/components/static/CTA.js